import { BaseModel } from "sjs-base-model";

export default class BaseCompanyModel extends BaseModel {
  public readonly id: number = 0;
  public readonly created: string = "";
  public readonly modifed: string = "";
  public readonly status: string = "";
  public readonly status_changed: string = "";
  public readonly is_removed: boolean = false;
  public readonly slug: string = "";
  public readonly name: string = "";
  public readonly logo: string = "";
  public readonly website: string = "";
  public readonly phone_number: string = "";
  public readonly fax_number: string = "";
  public readonly address: string = "";
  public readonly extra_contact_info: string = "";
  public readonly authorized_person: string = "";
  public readonly authorized_person_position: string = "";
  public readonly description: string = "";
  public readonly email: string = "";
  public readonly created_by: number = 0;

  constructor(data: Partial<BaseCompanyModel>) {
    super();

    this.update(data);
  }
}
